import React, { Component } from 'react';
import StackGrid from 'react-stack-grid';
import { ClipLoader } from 'react-spinners';
import { Link } from 'react-router-dom';
import Header from './common/Header';
import Footer from './common/Footer';
import NotFound from './common/NotFound';
import FloorChooser from './common/FloorChooser';
import style from './Category.module.css';
import withTracker from '../withTracker';

class Category extends Component {
  state = {
    data: null,
    originalData: null,
    filterFloor: null
  }

  colors = [
    '#01A58D',
    '#F7715D',
    '#155e63',
    '#1d97c1'
  ]

  constructor(props) {
    super(props);
    const {
      category
    } = props.match.params;

    let promise;

    if (category === 'store') {
      promise = () => import('../assets/data/store.json');
    } else if (category === 'exhibition') {
      promise = () => import('../assets/data/exhibition.json');
    }

    if (promise) {
      promise().then(data => this.setState({ data: data, originalData: data })).catch(err => console.error(err));
    } else {
      this.render = () => (<NotFound />);
    }
  }

  componentWillReceiveProps(props) {
    const {
      category
    } = props.match.params;

    let promise;

    if (category === 'store') {
      promise = () => import('../assets/data/store.json');
    } else if (category === 'exhibition') {
      promise = () => import('../assets/data/exhibition.json');
    }

    if (promise) {
      promise().then(data => this.setState({ data: data, originalData: data })).catch(err => console.error(err));
    } else {
      this.render = () => (<NotFound />);
    }
  }

  getJapaneseCategory(category) {
    if (category === 'exhibition') {
      return '展示';
    } else if (category === 'store') {
      return '模擬店';
    }
  }

  updateFloor(floor) {
    const {
      originalData
    } = this.state;

    if (floor) {
      const data = originalData.filter(item => item.floor === floor);

      this.setState({ data });
    } else {
      this.setState({
        data: this.state.originalData
      });
    }
    if (this.grid) this.grid.updateLayout();
  }

  render() {
    const {
      category
    } = this.props.match.params;

    const {
      data
    } = this.state;

    return [
      (
        <Header key='header' { ...this.props } title='カテゴリーで探す' />
      ),
      (
        <main key='content' className={style.main}>
          {
            data ? [
              (
                <StackGrid duration={0} columnWidth={300} gutterHeight={20} gutterWidth={20} vendorPrefix={true}>
                  <h1 style={{ display: 'block', width: '100%' }}>{this.getJapaneseCategory(category)}</h1>
                </StackGrid>
              ),
              (
                <div key='spacer1' style={{ height: 20 }}></div>
              ),
              (
                <FloorChooser onUpdateSelectedFloor={this.updateFloor.bind(this)} />
              ),
              (
                <div key='spacer2' style={{ height: 20 }}></div>
              ),
              (data || []).length ? null : (
                <h4 style={{ paddingTop: 60, paddingBottom: 60, textAlign: 'center' }}>条件に合うデータはありません。</h4>
              ),
              (
                <StackGrid className={style.grid} columnWidth={300} gutterHeight={20} gutterWidth={20} vendorPrefix={true}>
                  {
                    data.map((_, index) => {
                      let icon = null;
                      try {
                        delete require.cache[require.resolve(`../assets/img/icon/${_.category[0]}/${_.icon_name ? _.icon_name : _.name}.png`)];
                        icon = require(`../assets/img/icon/${_.category[0]}/${_.icon_name ? _.icon_name : _.name}.png`);
                      } catch (error) {}
                      
                      return (
                        <div className={style.category_item} style={{ backgroundColor: this.colors[index % this.colors.length] }} key={`${_.name}-container`}>
                          <h3 key={`${_.name}-h3`}>{_.room.join(' / ')}</h3>
                          <h2>{_.name}</h2>
                          {
                            icon ? (
                              <img src={ icon } />
                            ) : (
                              <img src="https://dummyimage.com/200x200/333/fff.jpg" />
                            )
                          }
                          {
                            _.description.split('\n').map((line, i) => (
                              <p key={`${_.name}-line-${i}`} className={style.description}>{ line }</p>
                            ))
                          }
                          <p style={{ textAlign: 'center' }}><Link className={style.detail_button} to={`/detail/${category}/${_.key || _.name}.html`}>詳細</Link></p>
                        </div>
                      )
                    })
                  }
                </StackGrid>
              ),
              (
                <div key='spacer3' style={{ height: 20 }}></div>
              )
            ] : (
              <div>
                <StackGrid gridRef={grid => this.grid = grid} duration={0} columnWidth={300} gutterHeight={20} gutterWidth={20} vendorPrefix={true}>
                  <h1 style={{ display: 'block', width: '100%' }}>{this.getJapaneseCategory(category)}</h1>
                </StackGrid>
                  <div className={style.spinner}>
                    <ClipLoader size={100} color={'#888'} />
                    <p style={{ textAlign: 'center', color: '#888' }}>Loading...</p>
                  </div>
              </div>
            )
          }
        </main>
      ),
      (
        <Footer key='footer' {...this.props} />
      )
    ];
  }
}

export default Category;



// WEBPACK FOOTER //
// ./src/components/Category.js